export const GET_INQUIRY = 'GET_INQUIRY'
export const SET_INQUIRY = 'SET_INQUIRY'
